// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var DeviceType_Enum;
(function (DeviceType_Enum) {
    DeviceType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceType_Enum["DESK_PHONE"] = "DESK_PHONE";
    DeviceType_Enum["SOFTPHONE"] = "SOFTPHONE";
    DeviceType_Enum["MOBILE_APP"] = "MOBILE_APP";
})(DeviceType_Enum || (DeviceType_Enum = {}));
export var DeviceType_Enum_index;
(function (DeviceType_Enum_index) {
    DeviceType_Enum_index[DeviceType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceType_Enum_index[DeviceType_Enum_index["DESK_PHONE"] = 1] = "DESK_PHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["SOFTPHONE"] = 2] = "SOFTPHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["MOBILE_APP"] = 3] = "MOBILE_APP";
})(DeviceType_Enum_index || (DeviceType_Enum_index = {}));
export const SipProfileAPI = {
    List(fn, req) {
        return fn(`/phone/sip-profiles/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Update(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["sipProfile"]) === null || _a === void 0 ? void 0 : _a["sipProfileId"], "sipProfile.sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${(_b = req["sipProfile"]) === null || _b === void 0 ? void 0 : _b["sipProfileId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetCallGroups(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${req["sipProfileId"]}/call-groups?${fm.renderURLSearchParams(req, ["sipProfileId"])}`, { method: "GET" });
    },
    ReplaceCallGroups(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${req["sipProfileId"]}/call-groups`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetRegistration(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${req["sipProfileId"]}/registration?${fm.renderURLSearchParams(req, ["sipProfileId"])}`, { method: "GET" });
    },
    GetDND(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${req["sipProfileId"]}/dnd?${fm.renderURLSearchParams(req, ["sipProfileId"])}`, { method: "GET" });
    },
    UpdateDND(fn, req) {
        try {
            fm.validateUrlParam(req["sipProfileId"], "sipProfileId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/sip-profiles/v1/${req["sipProfileId"]}/dnd`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
